import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useImperativeHandle, useRef, useContext } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { GlobalContext } from '../context-provider';
export var AvatarGroupContext = /*#__PURE__*/React.createContext({
  isGroup: false,
  shape: 'circle',
  size: 'small'
});
/** 头像叠层 */

export var Group = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'circle' : _props$shape,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$zIndexOrder = props.zIndexOrder,
      zIndexOrder = _props$zIndexOrder === void 0 ? 'desc' : _props$zIndexOrder,
      children = props.children;

  var _useContext = useContext(GlobalContext),
      prefixCls = _useContext.prefixCls;

  var childrenArr = React.Children.toArray(children);
  var length = childrenArr.length;
  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: domRef,
    style: style,
    className: cls(className, prefixCls + "-avatar-group", "group-" + size)
  }, /*#__PURE__*/React.createElement(AvatarGroupContext.Provider, {
    value: {
      isGroup: true,
      shape: shape,
      size: size
    }
  }, childrenArr.map(function (child, i) {
    var childProps = (child || {}).props;

    var avatarStyle = _extends({
      zIndex: zIndexOrder === 'asc' ? i + 1 : length - i
    }, childProps.style);

    return /*#__PURE__*/React.cloneElement(child, _extends({}, childProps, {
      style: avatarStyle
    }));
  })));
});
export default Group;